import React from 'react';
import { Router } from '@reach/router';

import TrainingSessionPage from '../TrainingSessionSection/TrainingSessionPage';
import PoseComparisonSection from '../PoseComparisonSection/PoseComparisonSection';
import PoseComparisonOverviewSection from '../PoseComparisonOverviewSection/PoseComparisonOverviewSection';
import HomeSection from '../HomeSection/HomeSection';
import CourseOverviewSection from '../CourseOverviewSection/CourseOverviewSection';
import CourseDetailSection from '../CourseDetailSection/CourseDetailSection';
import InstructorDetailSection from '../InstructorDetailSection/InstructorDetailSection';
import ExplainerSection from '../ExplainerSection/ExplainerSection';
import MyAccountSection from '../MyAccountSection/MyAccountSection';
import FinishSessionSection from '../FinishSessionSection/FinishSessionSection';
import MobileGate from '../MobileGate/MobileGate';
import LoadingGate from '../LoadingGate/LoadingGate';
import SubscriptionGate from '../SubscriptionGate/SubscriptionGate';
import useGateInformation, {
  GATE_INFORMATION,
} from '../../../hooks/useGateInformation';
import JourneyProgressPage from '../../03_organisms/JourneyProgress/JourneyProgressPage';
import MeinBereichSection from '../MeinBereichSection/MeinBereichSection';
import AccountGate from '../AccountGate/AccountGate';
import CookieManager from '../../02_molecules/CookieManager/CookieManager';
import StripeGate from '../StripeGate/StripeGate';
import { useStripe } from '../../../context/StripeContext';
import useAuth from '../../../hooks/useAuth';
import useSubscriptionStatus from '../../../hooks/useSubscriptionStatus';

const AppSection: React.FC = () => {
  const {isStripePayment} = useStripe();
  const { user } = useAuth();
  const [, forceUpdate] = React.useState({});
  const  gate  = useGateInformation();
  const { data: subscriptionStatus, hasFullAppAccess } =
    useSubscriptionStatus();
  console.log('hasFullAppAccess', hasFullAppAccess)

  // Add render count debugging
  const renderCount = React.useRef(0);
  renderCount.current++;
  console.log('AppSection render #', renderCount.current, 'with gate:');
  if (isStripePayment && !hasFullAppAccess) {
    return <StripeGate />;
  }

  switch (gate) {
    case GATE_INFORMATION.MOBILE:
      return <MobileGate />;

    case GATE_INFORMATION.ACCOUNT_INVALID:
      return <AccountGate />;

    case GATE_INFORMATION.LICENSE:
      return <SubscriptionGate />;

    case GATE_INFORMATION.LOADING:
      return <LoadingGate />;

    case GATE_INFORMATION.PASS:
    default:
      return (
        <Router basepath="/app">
          <HomeSection path="/" />
          <ExplainerSection path="/how-it-works" />
          <MyAccountSection path="/my-account" />
          <CookieManager path="/my-account/cookie-manager" />
          <MeinBereichSection path="/mein-bereich" />
          <TrainingSessionPage path="/session/:videoId" />
          <FinishSessionSection path="/finish-session/:trainingSessionId/:rawFeedback" />
          <PoseComparisonSection path="/pose-comparison/:sessionId" />
          <PoseComparisonOverviewSection path="/pose-comparison" />
          <CourseOverviewSection path="/courses" />
          <CourseDetailSection
            path="/course-detail/:courseId"
            key={'asdasdasda'}
          />
          <CourseDetailSection
            path="/course-detail/:courseId/:startIntro"
            key={'asdasdasasadsada'}
          />
          <InstructorDetailSection path="/instructor-detail/:instructorId" />
          <JourneyProgressPage path="/journey/:courseId" />
        </Router>
      );
  }
};

export default React.memo(AppSection);
